document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.custom-logoes');
  if (!section) return;

  const track = section.querySelector('.grid--slider');
  if (!track) return;

  const items = Array.from(track.children);

  // Clone once for infinite loop
  items.forEach(item => {
    const clone = item.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  let position = 0;
  const speed = 0.8;

  function animate() {
    position -= speed;

    const resetPoint = track.scrollWidth / 2;
    if (Math.abs(position) >= resetPoint) {
      position = 0;
    }

    track.style.transform = `translate3d(${position}px, 0, 0)`;
    requestAnimationFrame(animate);
  }

  animate();
});


// youtube video app
(function () {
  const fixSlider = () => {
    const swiperEl = document.querySelector('.reputon-swiper');
    if (!swiperEl || !swiperEl.swiper) return;

    const swiper = swiperEl.swiper;
    const isMobile = window.innerWidth <= 767;

    // Responsive settings
    swiper.params.slidesPerView = isMobile ? 1 : 3;
    swiper.params.centeredSlides = false;
    swiper.params.spaceBetween = isMobile ? 12 : 20;
    swiper.params.slidesOffsetBefore = 0;
    swiper.params.slidesOffsetAfter = 0;

    swiper.update();

    // Prevent left cut-off issue
    swiper.slideTo(0, 0);
  };

  // Watch if the app tries to reinitialize/reset Swiper
  const observer = new MutationObserver(fixSlider);
  const target = document.querySelector('.reputon-swiper');

  if (target) {
    observer.observe(target, { attributes: true, childList: true, subtree: true });
  }

  window.addEventListener('load', () => {
    setTimeout(fixSlider, 1000);
  });

  window.addEventListener('resize', fixSlider);
})();

// home slider video load image 

document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('.video-el');
  const poster = document.querySelector('.video-poster');

  if (!video || !poster) return;

  video.addEventListener('canplay', () => {
    video.style.opacity = '1';
    poster.style.opacity = '0';
    poster.style.transition = 'opacity 0.4s ease';
    setTimeout(() => poster.remove(), 400);
  });
});



(function() {
    const fixSwiper = () => {
        // Target the container using the class from your HTML
        const container = document.querySelector('.swiper.swiper-initialized');
        
        if (container && container.swiper) {
            const instance = container.swiper;

            if (window.innerWidth >= 1024) {
                // 1. Force internal parameters
                instance.params.slidesPerView = 3;
                instance.params.slidesPerGroup = 1;
                instance.params.centeredSlides = false; // Ensures they align left-to-right
                
                // 2. Update the layout
                instance.update();
                
                // 3. Optional: Re-calculate if the widget tries to revert
                instance.on('resize', () => {
                    if (window.innerWidth >= 1024) {
                        instance.params.slidesPerView = 3;
                        instance.update();
                    }
                });
            }
        }
    };

    // Fix the "Node" error by ensuring the DOM is fully interactive
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        fixSwiper();
        setupObserver();
    } else {
        window.addEventListener('DOMContentLoaded', () => {
            fixSwiper();
            setupObserver();
        });
    }

    function setupObserver() {
        if (!document.body) return; // Final safety check

        const observer = new MutationObserver((mutations) => {
            // If the swiper class appears or changes, re-run the fix
            if (document.querySelector('.swiper-initialized')) {
                fixSwiper();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('resize', fixSwiper);
})();


// product dots

document.addEventListener("DOMContentLoaded", function() {
    const slider = document.querySelector('.product-gallery.product-gallery--slider.lap--grid--slider-container .css-slider.css-slider--bottom-navigation');
    const thumbHolder = document.querySelector('.product-gallery__thumbnails-holder');
    
    if (slider && thumbHolder) {
        const thumbnails = thumbHolder.querySelectorAll('.thumbnail');
        
        // 1. Create the container for dots
        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'custom-gallery-dots';
        
        // 2. Create a dot for each thumbnail
        thumbnails.forEach((thumb, index) => {
            const dot = document.createElement('span');
            dot.className = 'gallery-dot';
            if (thumb.classList.contains('active')) {
                dot.classList.add('active');
            }
            
            dot.addEventListener('click', () => thumb.click());
            dotsContainer.appendChild(dot);
        });

        // 3. Append to the slider container
        slider.appendChild(dotsContainer);

        // 4. Update dots when a thumbnail state changes
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const allThumbs = Array.from(thumbnails);
                    const activeIndex = allThumbs.findIndex(t => t.classList.contains('active'));
                    const allDots = dotsContainer.querySelectorAll('.gallery-dot');
                    
                    allDots.forEach(d => d.classList.remove('active'));
                    if (allDots[activeIndex]) {
                        allDots[activeIndex].classList.add('active');
                    }
                }
            });
        });

        // Observe each thumbnail for class changes (active state)
        thumbnails.forEach(thumb => observer.observe(thumb, { attributes: true }));
    }
});


document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Define the selectors based on your inspect code
  const mainInputSelector = '.product-quantity .qty-selector';
  const stickyInputSelector = 'input[id^="StickyQuantity-"]';

  const syncAll = (newValue) => {
    const allInputs = document.querySelectorAll(`${mainInputSelector}, ${stickyInputSelector}`);
    allInputs.forEach(input => {
      if (input.value !== newValue) {
        input.value = newValue;
        // Trigger events so the theme knows the value changed
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  // 2. Listen for clicks on ALL plus/minus buttons (Main AND Sticky)
  document.addEventListener('click', function(e) {
    // Check if it's a theme button (.qty-button) or our sticky button (.qty-btn)
    const btn = e.target.closest('.qty-button, .qty-btn');
    if (!btn) return;

    // Small delay to let the theme's own script finish updating the number first
    setTimeout(() => {
      const parentContainer = btn.closest('product-quantity, .sticky-add-to-cart__quantity');
      if (parentContainer) {
        const input = parentContainer.querySelector('input[type="number"]');
        if (input) syncAll(input.value);
      }
    }, 50); 
  });

  // 3. Listen for manual typing in any quantity box
  document.addEventListener('input', function(e) {
    if (e.target.matches(`${mainInputSelector}, ${stickyInputSelector}`)) {
      syncAll(e.target.value);
    }
  });
});



// ifream 

// function syncVideoHeight() {
//   const videoWrappers = document.querySelectorAll('.vimeo-video-wrapper');
//   console.log(videoWrappers);

//   videoWrappers.forEach(wrapper => {
//     const height = wrapper.offsetHeight;

//     document.querySelectorAll('.element--height-auto').forEach(el => {
//       el.style.height = height + 'px';
//     });
//   });
// }

// window.addEventListener('load', syncVideoHeight);
// window.addEventListener('resize', syncVideoHeight);

// theme file js 
// (function() {

//         function syncVideoHeight() {
//           const videoWrappers = document.querySelectorAll('.vimeo-video-wrapper');

//           videoWrappers.forEach(wrapper => {
//             const height = wrapper.offsetHeight;

//             document.querySelectorAll('.element--height-auto').forEach(el => {
//               el.style.height = height + 'px';
//             });
//           });
//         }

//         document.addEventListener('DOMContentLoaded', syncVideoHeight);
//         window.addEventListener('resize', syncVideoHeight);
//         document.addEventListener('shopify:section:load', syncVideoHeight);

//       })();

document.querySelectorAll('.vimeo-iframe').forEach(function(iframe){
  iframe.addEventListener('load', function(){

    iframe.style.opacity = 1;

    const placeholder = iframe.parentElement.querySelector('.vimeo-placeholder');
    if(placeholder){
      placeholder.style.display = 'none';
    }

  });
});

// document.addEventListener("click", function(e){

//   const btn = e.target.closest(".comparison-btn");
//   if(!btn) return;

//   e.preventDefault();

//   const variantId = btn.dataset.variant;
//   if(!variantId) return;

//   const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
//   const realATC = document.querySelector("[data-js-atc]");

//   if(!variantInput || !realATC) return;

//   /* store original variant */
//   const originalVariant = variantInput.value;

//   /* temporarily switch variant */
//   variantInput.value = variantId;

//   /* trigger real add to cart */
//   realATC.click();

//   /* restore original variant after add */
//   setTimeout(function(){
//     variantInput.value = originalVariant;
//   }, 300);

// });


document.addEventListener("click", function(e){

  const btn = e.target.closest(".comparison-btn");
  if(!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variant;
  if(!variantId) return;

  const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  const qtyInput = document.querySelector('[data-js-atc-qty]');
  const realATC = document.querySelector("[data-js-atc]");

  if(!variantInput || !realATC) return;

  /* store original values */
  const originalVariant = variantInput.value;
  const originalQty = qtyInput ? qtyInput.value : 1;

  /* temporarily switch variant + qty */
  variantInput.value = variantId;

  if(qtyInput){
    qtyInput.value = 1;
  }

  /* trigger real add to cart */
  realATC.click();

  /* restore original values */
  setTimeout(function(){
    variantInput.value = originalVariant;

    if(qtyInput){
      qtyInput.value = originalQty;
    }
  }, 300);

});


// (function () {

//   function syncVideoHeight() {

//     const slide = document.querySelector('.main-slide-one');
//     const videoWrapper = document.querySelector('.main-slide-one .vimeo-video-wrapper');

//     if (!slide || !videoWrapper) return;

//     const height = slide.offsetHeight;

//     videoWrapper.style.height = height + 'px';
//     videoWrapper.style.paddingTop = '0'; // override 56.25%
//   }

//   document.addEventListener('DOMContentLoaded', syncVideoHeight);
//   window.addEventListener('resize', syncVideoHeight);

// })();
 
// ── Add-on Toggle: silent cart add/remove + price display ──
(function () {
  var addons = {}; // variantId → { active, price, name, lineKey, btn }

  /* Refresh cart sidebar HTML + badges without opening the drawer.
     Mirrors window.refreshCart() from component-cart.js but omits .show(). */
  function silentCartRefresh() {
    fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var cartForm    = document.getElementById('AjaxCartForm');
        var newForm     = doc.getElementById('AjaxCartForm');
        var cartSub     = document.getElementById('AjaxCartSubtotal');
        var newSub      = doc.getElementById('AjaxCartSubtotal');

        if (cartForm && newForm) {
          cartForm.innerHTML = newForm.innerHTML;
          if (typeof cartForm.ajaxifyCartItems === 'function') cartForm.ajaxifyCartItems();
          document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
            var c = cartForm.querySelector('[data-cart-count]');
            if (c) el.textContent = c.textContent;
          });
          document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
            var t = cartForm.querySelector('[data-cart-total]');
            if (t) el.textContent = t.textContent;
          });
        }

        if (cartSub && newSub) cartSub.innerHTML = newSub.innerHTML;
        /* deliberately NOT calling .show() — drawer stays closed */
      })
      .catch(function () {}); /* swallow network errors silently */
  }

  function fmt(cents) {
    var f = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    return f.replace(/\{\{amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\}\}/g, function (m, s) {
      if (!s) return amt;
      if (s === '_no_decimals') return String(Math.round(cents / 100));
      return amt.replace('.', ',');
    });
  }

  function updatePriceDisplay() {
    var total = 0;
    Object.keys(addons).forEach(function (vid) { if (addons[vid].active) total += addons[vid].price; });
    var el = document.querySelector('.pbb__addon-price-display');
    if (!el) return;
    if (total > 0) {
      el.querySelector('.pbb__addon-price-display__amount').textContent = '+ ' + fmt(total) + ' in add-ons';
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', '');
    }
  }

  function injectPriceDisplay(section) {
    if (section.querySelector('.pbb__addon-price-display')) return;
    var anchor = section.querySelector('.main-product-price');
    if (!anchor) return;
    var el = document.createElement('div');
    el.className = 'pbb__addon-price-display';
    el.setAttribute('hidden', '');
    el.innerHTML = '<span class="pbb__addon-price-display__amount"></span>';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
  }

  function setActive(btn, vid, active) {
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    if (addons[vid]) addons[vid].active = active;
    updatePriceDisplay();
  }

  function addToCart(btn, vid, price, name) {
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: { _addon_toggle: 'true' } }] })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.disabled = false;
      if (data.status >= 400) { console.warn('Add-on add failed:', data.description); return; }
      var lineKey = data.items && data.items[0] ? data.items[0].key : null;
      addons[vid].lineKey = lineKey;
      if (lineKey) sessionStorage.setItem('addon_key_' + vid, lineKey);
      setActive(btn, vid, true);
      // update theme cart count without opening drawer
      silentCartRefresh();
    })
    .catch(function () { btn.disabled = false; });
  }

  function removeFromCart(btn, vid) {
    var key = (addons[vid] && addons[vid].lineKey) || sessionStorage.getItem('addon_key_' + vid);
    btn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: key
        ? JSON.stringify({ id: key, quantity: 0 })
        : JSON.stringify({ id: parseInt(vid, 10), quantity: 0 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.disabled = false;
      sessionStorage.removeItem('addon_key_' + vid);
      if (addons[vid]) { addons[vid].lineKey = null; }
      setActive(btn, vid, false);
      silentCartRefresh();
    })
    .catch(function () { btn.disabled = false; });
  }

  function initBlock(block) {
    var btn = block.querySelector('.pbb__addon-toggle-btn');
    if (!btn || block.dataset._addonInit) return;
    block.dataset._addonInit = '1';
    var vid = block.dataset.variantId;
    var price = parseInt(block.dataset.addonPrice, 10);
    var name = (block.querySelector('.pbb__addon-name') || {}).textContent || '';
    addons[vid] = { active: false, price: price, name: name.trim(), lineKey: null, btn: btn };

    // Restore state from sessionStorage
    var storedKey = sessionStorage.getItem('addon_key_' + vid);
    if (storedKey) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (i) { return i.key === storedKey; });
          if (item) { addons[vid].lineKey = storedKey; setActive(btn, vid, true); }
          else { sessionStorage.removeItem('addon_key_' + vid); }
        });
    }

    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-pressed') === 'true') removeFromCart(btn, vid);
      else addToCart(btn, vid, price, name);
    });
  }

  function agSlideDown(el, ms) {
    el.style.removeProperty('display');
    if (window.getComputedStyle(el).display === 'none') el.style.display = 'block';
    var h = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0';
    el.offsetHeight; // force reflow
    el.style.boxSizing = 'border-box';
    el.style.transitionProperty = 'height';
    el.style.transitionDuration = ms + 'ms';
    el.style.height = h + 'px';
    setTimeout(function () {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, ms);
  }

  function agSlideUp(el, ms) {
    el.style.transitionProperty = 'height';
    el.style.transitionDuration = ms + 'ms';
    el.style.boxSizing = 'border-box';
    el.style.height = el.offsetHeight + 'px';
    el.offsetHeight; // force reflow
    el.style.overflow = 'hidden';
    el.style.height = '0';
    setTimeout(function () {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, ms);
  }

  function initGroup(group) {
    if (group.dataset._groupInit) return;
    group.dataset._groupInit = '1';
    var overflow = group.querySelector('.pbb__addon-group__overflow');
    var expandBtn = group.querySelector('.pbb__addon-group__expand');
    if (!expandBtn || !overflow) return;
    var expanded = false;
    var extra = parseInt(expandBtn.dataset.extra, 10) || 0;

    function collapse() {
      expanded = false;
      expandBtn.setAttribute('aria-expanded', 'false');
      expandBtn.querySelector('.pbb__addon-group__expand-label').textContent = '+ ' + extra + ' more';
      agSlideUp(overflow, 200);
    }

    expandBtn.addEventListener('click', function () {
      expanded = !expanded;
      expandBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      expandBtn.querySelector('.pbb__addon-group__expand-label').textContent =
        expanded ? '− Show less' : '+ ' + extra + ' more';
      if (expanded) agSlideDown(overflow, 200);
      else agSlideUp(overflow, 200);
    });

    /* Clicking anywhere in the block while expanded closes it,
       unless the click is on an item toggle button (cart interaction). */
    group.addEventListener('click', function (e) {
      if (!expanded) return;
      if (e.target.closest('.pbb__addon-toggle-btn')) return;
      if (e.target.closest('.pbb__addon-group__expand')) return;
      collapse();
    });
  }

  function init() {
    document.querySelectorAll('.pbb__addon-block').forEach(function (block) {
      var section = block.closest('[id^="shopify-section-"]') || document;
      injectPriceDisplay(section);
      initBlock(block);
    });
    document.querySelectorAll('.pbb__addon-group').forEach(function (group) {
      initGroup(group);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { addons = {}; init(); });
})();

// ── Highlights: hide dividers that are orphaned at the end of a wrapped row ──
(function () {
  function fixHighlightDividers() {
    document.querySelectorAll('.product-highlights__items').forEach(function (container) {
      // Reset all first, then re-evaluate (handles resize making rows wider)
      container.querySelectorAll('.product-highlights__divider').forEach(function (d) {
        d.style.display = '';
      });
      if (!container.offsetParent) return; // container is hidden — skip measuring
      container.querySelectorAll('.product-highlights__divider').forEach(function (divider) {
        var prev = divider.previousElementSibling;
        var next = divider.nextElementSibling;
        var hide = false;
        // Hide if next item is on a new lower row (divider is orphaned at row end)
        if (next && next.classList.contains('product-highlights__item') && next.offsetTop > divider.offsetTop) {
          hide = true;
        }
        // Hide if previous item is on a higher row (divider is first on a new row)
        if (prev && prev.classList.contains('product-highlights__item') && prev.offsetTop < divider.offsetTop) {
          hide = true;
        }
        divider.style.display = hide ? 'none' : '';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', fixHighlightDividers);
  window.addEventListener('resize', fixHighlightDividers);

  // Re-run after a toggle tab opens (double rAF ensures layout is painted)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-js-title]')) {
      requestAnimationFrame(function () { requestAnimationFrame(fixHighlightDividers); });
    }
  });

  document.addEventListener('shopify:section:load', fixHighlightDividers);
})();

// ── Variant swatch: navigate to image instantly (no smooth scroll) ──
(function () {
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.product-variant-value')) return;
    var page = e.target.closest('product-page');
    if (!page) return;
    var slider = page.querySelector('[data-js-product-gallery] css-slider');
    if (!slider || !slider.element) return;
    var el = slider.element;
    var orig = el.scrollTo.bind(el);
    el.scrollTo = function (opts) {
      el.scrollTo = orig;
      orig(typeof opts === 'object' ? Object.assign({}, opts, { behavior: 'instant' }) : opts);
    };
  }, true);
})();

document.addEventListener("DOMContentLoaded", function(){

  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  document.head.appendChild(tag);

  window.onYouTubeIframeAPIReady = function(){

    document.querySelectorAll(".youtube-video-iframe").forEach(function(iframe){

      const wrapper = iframe.closest(".youtube-video-wrapper");

      const player = new YT.Player(iframe, {

        events: {

          onReady: function(event){

            const p = event.target;

            p.mute();

            /* Request higher quality */
            p.setPlaybackQuality('hd1080'); 
            // use 'hd1080' if the video supports 1080
            // use 'hd2160' if the video supports 4K

            p.playVideo();

            /* Prevent reaching the real end of video */
            setInterval(function(){

              const duration = p.getDuration();
              const current = p.getCurrentTime();

              if(duration && current > duration - 0.4){
                p.seekTo(0);
              }

            }, 200);

          },

          onStateChange: function(event){

            if(event.data === YT.PlayerState.PLAYING){
              wrapper.classList.add("video-loaded");
            }

          }

        }

      });

    });

  };

/* ── Tooltip click-to-toggle: delivery estimate + business buyers ── */
(function () {
  document.addEventListener('click', function (e) {
    /* ─ Delivery estimate ─ */
    if (!e.target.closest('.deliv-est__bubble')) {
      var tip = e.target.closest('.deliv-est__tip');
      if (tip) {
        var est = tip.closest('.deliv-est');
        if (est) est.classList.toggle('is-open');
      } else {
        document.querySelectorAll('.deliv-est.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
      }
    }
    /* ─ Business buyers ─ */
    if (!e.target.closest('.bus-buyers__bubble')) {
      var wrap = e.target.closest('.bus-buyers__wrap');
      if (wrap) {
        wrap.classList.toggle('is-open');
      } else {
        document.querySelectorAll('.bus-buyers__wrap.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
      }
    }
  });
})();

/* ── Zoom viewer: click anywhere to close ── */
(function () {
  document.addEventListener('click', function (e) {
    var zoom = document.getElementById('zoom');
    if (!zoom || !zoom.classList.contains('opened')) return;
    if (e.target.closest('.zoom__exit')) return;
    // Ignore the click that opened the zoom (originated on the zoom trigger)
    if (e.target.closest('product-image-zoom')) return;
    var exit = zoom.querySelector('.zoom__exit');
    if (exit) exit.click();
  });
})();

// ── Variant picker: sold-out badge + buy-box-widget button sync ──
(function () {
  function initOosBadge() {
    document.querySelectorAll('.vp-hcard').forEach(function (hcard) {
      if (hcard.dataset._oosInit) return;
      hcard.dataset._oosInit = '1';
      var variantData = hcard.querySelector('[data-js-variant-data]');
      if (!variantData) return;

      function update() {
        var data;
        try { data = JSON.parse(variantData.textContent); } catch (e) { return; }
        var oos = !!(data && data.available === false);

        /* Color row sold-out badge */
        hcard.classList.toggle('vp-hcard--oos', oos);

        /* Buy-box-widget ATC button — theme only targets #product-form-SECTIONID,
           so the bbw form (different ID) never gets updated. Mirror it here. */
        var locales = window.KROWN && KROWN.settings && KROWN.settings.locales;
        document.querySelectorAll('.bbw__actions [data-js-product-add-to-cart]').forEach(function (btn) {
          var textEl = btn.querySelector('[data-js-product-add-to-cart-text]');
          if (oos) {
            btn.classList.add('disabled');
            if (textEl && locales) textEl.textContent = locales.products_sold_out_variant;
          } else {
            btn.classList.remove('disabled');
            if (textEl && locales) {
              textEl.textContent = textEl.hasAttribute('data-show-preorder-wording')
                ? locales.products_preorder_button
                : locales.products_add_to_cart_button;
            }
          }
        });
      }

      update();
      new MutationObserver(update).observe(variantData, { childList: true });
    });
  }
  initOosBadge(); /* already inside DOMContentLoaded — call directly */
  document.addEventListener('shopify:section:load', initOosBadge);
})();

/* ── Business buyers accordion ── */
(function () {
  function bbSlideDown(el, ms) {
    el.style.removeProperty('display');
    if (window.getComputedStyle(el).display === 'none') el.style.display = 'block';
    var h = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0';
    el.offsetHeight;
    el.style.boxSizing = 'border-box';
    el.style.transitionProperty = 'height';
    el.style.transitionDuration = ms + 'ms';
    el.style.height = h + 'px';
    setTimeout(function () {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, ms);
  }

  function bbSlideUp(el, ms) {
    el.style.transitionProperty = 'height';
    el.style.transitionDuration = ms + 'ms';
    el.style.boxSizing = 'border-box';
    el.style.height = el.offsetHeight + 'px';
    el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0';
    setTimeout(function () {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, ms);
  }

  function initBbAccordions() {
    document.querySelectorAll('.bus-buyers--has-accordion').forEach(function (container) {
      if (container.dataset._bbAccInit) return;
      container.dataset._bbAccInit = '1';
      var btn  = container.querySelector('.bus-buyers__acc-btn');
      var body = container.querySelector('.bus-buyers__acc-body');
      if (!btn || !body) return;

      container.addEventListener('click', function (e) {
        if (e.target.closest('.bus-buyers__bubble')) return; /* let tooltip bubble clicks through */
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          bbSlideUp(body, 220);
        } else {
          btn.setAttribute('aria-expanded', 'true');
          bbSlideDown(body, 220);
        }
      });
    });
  }

  initBbAccordions();
  document.addEventListener('shopify:section:load', initBbAccordions);
})();

/* ── Delivery estimate: inject date client-side so it always reflects today ── */
(function () {
  var MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];
  function ordinalSuffix(n) {
    var mod100 = n % 100;
    if (mod100 >= 11 && mod100 <= 13) return 'th';
    switch (n % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
  function injectDeliveryDates() {
    document.querySelectorAll('.deliv-est').forEach(function (el) {
      var days = parseInt(el.dataset.days, 10) || 10;
      var d = new Date();
      d.setDate(d.getDate() + days);
      var day = d.getDate();
      var dateEl = el.querySelector('.deliv-est__date');
      if (dateEl) dateEl.innerHTML = day + '<sup>' + ordinalSuffix(day) + '</sup> ' + MONTHS[d.getMonth()];
    });
  }
  injectDeliveryDates();
  document.addEventListener('shopify:section:load', injectDeliveryDates);
})();

});